import { gql } from '@apollo/client';

export const CREATE_ORDER = gql`
  mutation CreateOrder($order: OrderContractInput!) {
    createOrder(order: $order) {
      id
      orderStatus
      orderDate
      systemId
      deliveryDate
      products {
        brand
        eye {
          property
          value
        }
        materialCode
        packSize
        productQuantity
      }
      store {
        name
        address
        workingHours
        phone
        code
      }
      voucherId
    }
  }
`;
